import VerificationInput from "react-verification-input";

type VerificationCodeInputProps = {
  label?: string;
  twoFactorCode?: string;
  onChangeCode: (code: string) => void;
} 

const VerificationCodeInput = ({ label, twoFactorCode, onChangeCode }: VerificationCodeInputProps) => {
  return (
    <div className="d-flex flex-column mb-5">
      <label htmlFor="otpInput" className="mb-3 text-center">
        {label}
      </label>

      <VerificationInput
        classNames={{
          container: "m-auto",
          character: "code-input",
          characterSelected: "code-input selected",
        }}
        validChars="0-9"
        inputProps={{ inputMode: "numeric" }}
        value={twoFactorCode}
        onChange={onChangeCode}
        placeholder=""
      />
    </div>
  );
};
export default VerificationCodeInput;
